module.exports = __webpack_public_path__ + "media/images/xpass/icons/filter-active-bb730fcacf85259f98bd684a205fab51.svg";